<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2>{{ isNaccuUser ? $t('memberDataSection.factories') : $t('memberDataSection.buyingStation') }}</h2>
        <v-spacer></v-spacer>
        <!-- <v-btn
          color="primary"
          dark
          outlined
          class="mr-2 mb-2"
          @click="handleBulkImportParchmentDeliveries"
          v-if="getModulePermittedActions.post"
        >
          {{ $t('memberDataSection.parchmentDelivery.bulkImport.importButton') }}
       </v-btn> -->

       <v-menu offset-y v-if="getModulePermittedActions.post">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark outlined class="mr-2 mb-2" v-bind="attrs" v-on="on">
              {{ $t('memberDataSection.buyingStationOrder.bulkImport.importBulkData') }}
              <v-icon right>mdi-menu-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="handleBulkImportPurchaseOrders">
              <v-list-item-title>
                {{ isNaccuUser ? $t('memberDataSection.buyingStationOrder.bulkImport.importButtonCherry') : $t('memberDataSection.buyingStationOrder.bulkImport.importButton') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="handleBulkImportParchmentDeliveries">
              <v-list-item-title>
                {{ $t('memberDataSection.parchmentDelivery.bulkImport.importButton') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="handleBulkImportProcessingBatches">
              <v-list-item-title>
                {{ $t('memberDataSection.processingBatchBulkImport.bulkImport') }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn v-if="isNaccuUser && getModulePermittedActions.post" color="primary" dark class="mr-2 mb-2" @click="handleManageRoles">
          {{ isNaccuUser ? $t("memberDataSection.manageFactoryRoles") : $t("memberDataSection.manageBuyingStationRoles") }}
        </v-btn>
        <v-btn color="primary" dark class="mr-2 mb-2" @click="handleCreateBuyingStation" v-if="getModulePermittedActions.post">
          {{ isNaccuUser ? $t("memberDataSection.registerFactory") : $t("memberDataSection.registerBuyingStation") }}
        </v-btn>
      </div>
      <v-card elevation="0" class="px-5 mt-7">
        <v-card-text>
          <v-row style="margin-left:-30px; margin-bottom: 20px; margin-top: 15px;">
            <v-col cols="12">
              <v-data-table :headers="tableHeaders" :items="buyingStations" :items-per-page="10" :footer-props="{
                'items-per-page-options': [5, 10, 25, 50],
              }" item-key="id" hide-default-footer :loading="loading" :options.sync="options"
                :server-items-length="totalBuyingStations" :loading-text="$t('loadingData')
                  ">
                <template v-slot:top="{}">
                  <div class="d-flex align-center">

                    <div class="ml-3" style="width: 220px;">
                      <v-text-field style="width: 280px;" prepend-inner-icon="mdi-magnify" outlined height="5px"
                        :placeholder="isNaccuUser ? $t('memberDataSection.searchFactory') : $t('memberDataSection.searchBuyingStation')" dense v-model="search" @input="searchQuery"
                        class="shrink">
                      </v-text-field>
                    </div>


                    <v-spacer></v-spacer>
                    <div class="d-flex align-center mb-3">
                    <div class="py-1 title">
                      {{ fromBuyingStationList }} -
                      {{ toBuyingStationList }} {{ $t('of') }}
                      {{ totalBuyingStations }}
                    </div>
                    <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page <= 1"
                      @click="reportPageChange(false)">
                      <v-icon dark>
                        mdi-chevron-left
                      </v-icon>
                    </v-btn>
                    <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page >= totalPages"
                      @click="reportPageChange(true)">
                      <v-icon dark>
                        mdi-chevron-right
                      </v-icon>
                    </v-btn>
                    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" left :min-width="417">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mx-2" fab small outlined color="primary" v-bind="attrs" v-on="on">
                          <v-icon dark>mdi-cog-outline </v-icon>
                        </v-btn>
                      </template>
                      <v-card width="417">
                        <v-list>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>{{ $t("deforestation.customization")
                                }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider></v-divider>
                          <div class="pl-3 pt-2 font-weight-normal">
                            {{ $t("deforestation.recordsPerpage") }}
                          </div>
                          <v-list-item>
                            <v-list-item-content>
                              <v-slider v-model="itemsPerPageSlider" :tick-labels="itemsPerPageOptions" :max="3"
                                step="1" ticks="always" tick-size="4"></v-slider>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-n3"></v-divider>
                        </v-list>
                        <v-card-text>
                          <v-container fluid>
                            <v-row>
                              <v-col class="mt-n9" cols="6" v-for="header in headers" :key="header.value">
                                <v-checkbox v-if="header.text" v-model="selectedHeaders" :label="header.text"
                                  color="primary" :value="header.text" hide-details
                                  :disabled="header.text == 'ID'"></v-checkbox>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-layout justify-center>
                          <v-card-actions class="mb-5">
                            <v-spacer></v-spacer>

                            <v-btn outlined color="primary" @click="resetDefault" width="190">
                              <span class="text-truncate" style="max-width:150px">{{ $t("deforestation.restoreDefault")
                                }}</span>
                            </v-btn>
                            <v-btn color="primary" @click="resetTableStructure" width="190">
                              {{ $t("deforestation.apply") }}
                            </v-btn>
                          </v-card-actions>
                        </v-layout>
                      </v-card>
                    </v-menu>

                    <!-- <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mx-2" fab small outlined color="primary" v-bind="attrs" v-on="on"
                          @click="exportToPDF">
                          <v-icon dark> mdi-download </v-icon>
                        </v-btn>
                      </template>

                      <span>
                        {{ $t("deforestation.download") }}
                      </span>
                    </v-tooltip>
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mx-2" fab small outlined color="primary" v-bind="attrs" v-on="on"
                          @click="printPDF('document')">
                          <v-icon dark> mdi-printer </v-icon>
                        </v-btn>
                      </template>
                      <span>

                        {{ $t("deforestation.print") }}
                      </span>
                    </v-tooltip> -->
                    </div>
                  </div>
                </template>
                <template v-if="buyingStations.length" v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.id" style="position: relative; width: 0; height: 0"
                      @mouseover="selectItem(item)" @mouseleave="selectItem(false)">
                      <template v-for="h in tableHeaders">

                        <td class="text-truncate" :key="h.value + '_nameAndId'"
                          v-if="h.value == 'nameAndId'">
                          {{ item.name ? item.name : item.firstName + ' ' + item.lastName }}
                          <br />
                          {{ item.id_number ? item.id_number : 'N/A' }}
                        </td>

                        <td class="text-truncate" :key="h.value + '_email'"
                          v-else-if="h.value == 'email'">
                          {{ item.email ? item.email : "-" }}
                        </td>

                        <td class="text-truncate" :key="h.value + '_mobileNumber'"
                          v-else-if="h.value == 'mobileNumber'">
                          {{ item.mobileNumber ? item.mobileNumber : item.phoneNumber || "-" }}
                        </td>

                        <td class="text-truncate" :key="h.value + '_role'"
                          v-else-if="h.value == 'role'">
                          {{ item.role ? item.role : (isNaccuUser ? $t("memberDataSection.factory") : $t("memberDataSection.buyingStation")) }}
                        </td>

                        <td class="text-truncate" :key="h.value + '_status'"
                          v-else-if="h.value == 'status'">
                          <v-btn small rounded min-width="100" depressed class="green-button" height="40"
                              v-if="item.status === 'active'">
                              {{ $t("memberDataSection.active") }}
                          </v-btn>
                          <v-btn small rounded min-width="100" depressed class="red-button" height="40"
                              v-else-if="item.status === 'deactivated'">
                              {{ $t("memberDataSection.deactivated") }}
                          </v-btn>
                        </td>
                      </template>
                      
                      <!-- Action menu positioned absolutely -->
                      <div v-show="!hideOnPrint" style="position: absolute; right: -10px; top:10px;">
                        <v-menu offset-y left>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>

                          <v-list>
                            <v-list-item @click="navigateToFactoryDashboard(item)">
                              <v-list-item-title>{{ $t('dashboard') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="viewBuyingStation(item)">
                              <v-list-item-title>{{ $t('memberDataSection.view') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="editBuyingStation(item.id)" :disabled="!getModulePermittedActions.put">
                              <v-list-item-title>{{ $t('memberDataSection.edit') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="openConfirmActivate(item.id)" v-if="item.status === 'deactivated'" :disabled="!getModulePermittedActions.put">
                              <v-list-item-title class="green--text">{{ $t('memberDataSection.activate') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="openConfirmDeactivate(item.id)" v-if="item.status === 'active'" :disabled="!getModulePermittedActions.put">
                              <v-list-item-title class="red--text">{{ $t('memberDataSection.deactivate') }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </tr>
                  </tbody>
                </template>

                <template v-slot:footer></template>
              </v-data-table>

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- User Selection Modal (for NACCU users) -->
    <UserSelectionModal 
      v-if="isNaccuUser"
      :dialog="userSelectionDialog"
      @close="closeUserSelectionDialog"
      @optionSelected="handleUserOptionSelected"
    />

    <!-- NACCU Bulk Upload Dialog -->
    <UserBulkUpload
      v-if="isNaccuUser"
      :dialog="bulkUploadDialog"
      @close="closeBulkUploadDialog"
      @bulkUploadCompleted="handleBulkUploadCompleted"
    />

    <!-- Add App User Dialog (for non-NACCU users) -->
    <AddAppUser 
      v-if="!isNaccuUser"
      :dialogI="addUserDialog" 
      :isMarketPlaceUser="false"
      @closeAddUser="closeAddUserDialog"
      @userAdded="handleUserAdded"
    />

    <!-- Edit App User Dialog -->
    <EditUser
      v-if="isNaccuUser && editUserDialog && selectedBuyingStation"
      :dialogU="editUserDialog"
      :user="selectedBuyingStation"
      @closeUpdateUser="closeEditUserDialog"
      @appUserUpdated="handleUserUpdated"
    />
    <EditAppUser
      v-else-if="!isNaccuUser && editUserDialog && selectedBuyingStation"
      :dialogU="editUserDialog"
      :user="selectedBuyingStation"
      :isMarketPlaceUser="false"
      @closeUpdateUser="closeEditUserDialog"
      @appUserUpdated="handleUserUpdated"
    />

    <!-- Activate / Deactivate confirmation -->
    <ConfirmBox
      :title="confirmStatus.title"
      :message="confirmStatus.message"
      :cancelBtnText="$t('cancel')"
      :confirmBtnText="confirmStatus.confirmBtnText"
      :confirmData="confirmStatus.confirmData"
      :dialog="confirmStatusDialog"
      @cancel:action="confirmStatusDialog = false"
      @continue:action="handleConfirmStatus"
    />
  </div>


</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import download from "@/mixins/DownloadMixin";
import getPermittedActions from "@/mixins/GetPermittedActions";
import DateMixin from "@/mixins/DateMixin";
import html2pdf from "html2pdf.js";
import printJS from "print-js";
import moment from 'moment';
import RoleMixin from "@/mixins/RoleMixin";
import { isKenyaClient, isIndonesianClient } from "@/utils";
import AddAppUser from "@/views/user/AddAppUser.vue";
import EditAppUser from "@/views/user/EditAppUser.vue";
import EditUser from "@/views/user/naccu-user/EditUser.vue";
import BuyingStationService from "@/_services/BuyingStationService";
import UserSelectionModal from "@/views/user/naccu-user/UserSelectionModal.vue";
import UserBulkUpload from "@/views/user/naccu-user/UserBulkUpload.vue";
import ConfirmBox from "@/components/ConfirmBox.vue";

export default {
  components: {
    AddAppUser,
    EditAppUser,
    EditUser,
    UserSelectionModal,
    UserBulkUpload,
    ConfirmBox,
  },
  created() {
    this.getBuyingStations();
  },
  async mounted() {
    this.tableHeaders = this.headers;
    this.selectedHeaders = this.allSelectedHeaders;
  },
  watch: {
    options: {
      handler(opt) {
        this.getBuyingStations(opt);
      },
      deep: true,
    },
  },
  computed: {
    isNaccuUser() {
      return isKenyaClient();
    },
    isIndonesianUser() {
      return isIndonesianClient();
    },
    isOwner() {
      return this.getCurrentRoles.some(x => ["operator_owner", "supplier_owner"].includes(x))
    },
    getOrganizationId() {
      return this.$store.getters.getUser?.user_organization?.id;
    },
    reportHeaders() {
      return this.headers.filter(header => this.selectedHeaders.includes(header.text));
    },
    totalPages() {
      return parseInt(Math.ceil(this.totalBuyingStations / this.options.limit))
    },
    breadcrumbs() {
      return [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
        },
        {
          text: this.isNaccuUser ? this.$t("memberDataSection.factories") : this.$t("memberDataSection.buyingStation"),
          disabled: true,
          href: "breadcrumbs_link_1",
        },
      ];
    },
  },
  data() {
    return {
      debounceTimer: null,
      fromBuyingStationList: 0,
      toBuyingStationList: 0,
      search: "",
      copyReport: [],
      loading: true,
      selectedItem: false,
      options: {
        limit: 10,
        page: 1,
        sortBy: ['id'],
        sortDesc: [true],
      },
      headers: [
        {
          text: this.$t("memberDataSection.nameAndId"),
          align: "start",
          value: "nameAndId",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("memberDataSection.email"),
          align: "start",
          value: "email",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("memberDataSection.mobileNumber"),
          align: "start",
          value: "mobileNumber",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("memberDataSection.role"),
          align: "start",
          value: "role",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("memberDataSection.status"),
          align: "start",
          value: "status",
          class: "black--text",
          sortable: true,
        },
      ],
      allSelectedHeaders: [
        this.$t('memberDataSection.nameAndId'),
        this.$t('memberDataSection.email'),
        this.$t('memberDataSection.mobileNumber'),
        this.$t("memberDataSection.role"),
        this.$t("memberDataSection.status"),
      ],
      menu: false,
      buyingStations: [],
      totalBuyingStations: 0,
      totalBuyingStationPages: 0,
      customizeMenu: false,
      customizeMenuAll: false,
      itemsPerPageOptions: [5, 10, 25, 50],
      itemsPerPageSlider: 1,
      selectedHeaders: [],
      tableHeaders: [],
      addUserDialog: false,
      editUserDialog: false,
      selectedBuyingStation: null,
      userSelectionDialog: false,
      bulkUploadDialog: false,
      confirmDeleteDialog: false,
      confirmDelete: {
        title: this.$t("memberDataSection.confirmDialog.delete.title"),
        message: this.$t("memberDataSection.confirmDialog.delete.message"),
        confirmBtnText: this.$t("memberDataSection.confirmDialog.delete.confirmBtn"),
        cancelBtnText: this.$t("cancel"),
        confirmData: {},
      },
      confirmStatusDialog: false,
      confirmStatus: {
        title: "",
        message: "",
        confirmBtnText: "",
        confirmData: { id: null, action: null },
      },
      hideOnPrint: false,
    };
  },
  methods: {
    async exportToPDF() {
      const requestParams = {
        page: this.options.page,
        limit: this.options.limit,
        search: this.search,
      };
      const querys = new URLSearchParams(requestParams).toString();
      const token = this.$store.state.auth.token
      this.startLoading()
      const url = process.env.VUE_APP_API_BASE_URL || "https://api.dimitra.dev"
      this.downloadSourceFileWithToken(`${url}/buying-stations/pdf?${querys}`, "application/pdf", token, "buying-stations.pdf")
        .then(() => {
          this.stopLoading()
        }).catch(() => {
          this.stopLoading()
        })
    },

    async printPDF() {
      this.hideOnPrint = true;
      await this.$nextTick();
      const element = document.querySelector(".v-data-table__wrapper");
      let opt = {
        margin: 1,
        filename: "BuyingStationList.pdf",
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };

      try {
        let worker = await html2pdf()
          .set(opt)
          .from(element)
          .toCanvas()
          .outputPdf("blob", "BuyingStationList.pdf");
        let file = new File([worker], "BuyingStationList.pdf", {
          type: "application/pdf",
        });
        var pdfUrl = await URL.createObjectURL(file);
        await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
      } finally {
        this.hideOnPrint = false;
      }
    },
    async resetDefault() {
      this.tableHeaders = this.headers;
      this.selectedHeaders = this.allSelectedHeaders;
      this.menu = false;
      await this.getBuyingStations();
    },

    async resetTableStructure() {
      this.tableHeaders = this.headers.filter((header) =>
        this.selectedHeaders.includes(header.text)
      );
      this.options.limit = this.itemsPerPageOptions[
        this.itemsPerPageSlider
      ];
      await this.getBuyingStations();
      (this.customizeMenu = false), (this.customizeMenuAll = false);
    },

    getDateFormat(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    viewBuyingStation(item) {
      // Use path directly since route name is shared with other routes
      this.$router.push({
        path: `/coffee/buying-station/${item.id}`,
      });
    },

    navigateToFactoryDashboard(item){
      this.$router.push({
        path: `/coffee/factory-dashboard/${item.id}`,
      });
    },

    handleCreateBuyingStation() {
      // NACCU: show the Single/Multiple chooser (Single -> register page, Multiple -> bulk upload).
      // Non-NACCU clients keep the existing add-app-user dialog.
      if (this.isNaccuUser) {
        this.userSelectionDialog = true;
      } else {
        this.addUserDialog = true;
      }
    },

    handleBulkImportParchmentDeliveries() {
      this.$router.push({
        name: "CoffeeBuyingStationParchmentDeliveriesBulkImport",
      });
    },
    handleBulkImportProcessingBatches() {
      this.$router.push({ name: "ProcessingBatchBulkImport" });
    },
    handleBulkImportPurchaseOrders() {
      this.$router.push({
        name: "CoffeePurchaseOrdersBulkImport",
      });
    },
    searchQuery() {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.options.page = 1;
        this.getBuyingStations();
      }, 500)
    },
    async getBuyingStations(opt = null) {
      this.loading = true;
      const requestParams = {
        page: this.options.page || 1,
        limit: this.options.limit || 10,
        search: this.search || null,
      };

      const isDesc = Array.isArray(opt?.sortDesc) && opt.sortDesc.length > 0 ? Boolean(opt.sortDesc[0]) : true;
      requestParams.orderField = 'id';
      requestParams.order = isDesc ? 'DESC' : 'ASC';

      try {
        const listApi = this.isNaccuUser ? BuyingStationService.listFactories : BuyingStationService.listBuyingStations;
        const res = await listApi(requestParams);

        // Transform the API response to match the expected format
        const transformedData = res.data.rows.map(station => ({
          id: station.id,
          name: station.fullName || `${station.firstName || ''} ${station.middleName || ''} ${station.lastName || ''}`.trim(),
          firstName: station.firstName,
          middleName: station.middleName,
          lastName: station.lastName,
          id_number: station.id_number,
          email: station.email,
          mobileNumber: station.mobile,
          phoneNumber: station.mobile,
          role: this.isNaccuUser ? this.$t("memberDataSection.factory") : this.$t("memberDataSection.buyingStation"),
          status: station.active ? "active" : "deactivated",
          address: station.address
        }));

        this.buyingStations = transformedData;
        this.totalBuyingStations = res.data.totalRows;
        this.totalBuyingStationPages = Math.ceil(this.totalBuyingStations / this.options.limit);

        this.fromBuyingStationList = this.totalBuyingStations > 0
          ? (this.options.page - 1) * this.options.limit + 1
          : 0;
        this.toBuyingStationList = this.options.page * this.options.limit > this.totalBuyingStations
          ? this.totalBuyingStations
          : this.options.page * this.options.limit;

        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log("Error fetching buying stations:", err);
        this.$notify({
          text: "Error fetching buying stations",
          type: "error",
        });
      }
    },
  
    async editBuyingStation(id) {
      // Fetch full buying station details from the API
      try {
        const response = await BuyingStationService.getBuyingStationDetails(id);
        // API returns an object with { success, code, message, data }
        const station = response && response.data ? response.data : null;

        if (station) {
          if (this.isNaccuUser) {
            this.selectedBuyingStation = station;
          } else {
            // Map API response to EditAppUser expected structure for non-NACCU users.
            this.selectedBuyingStation = {
              id: station.id,
              firstName: station.firstName || "",
              middleName: station.middleName || "",
              lastName: station.lastName || "",
              email: station.email || "",
              mobile: station.mobile || "",
              phoneNumber: station.mobile || "",
              country: station.country || "",
              countryId: station.country || station.countryId || "",
              countryCode: station.countryIsoCode || station.countryCode || "",
              stateId: station.stateId || "",
              district: station.district || "",
              village: station.village || "",
              city: station.city || "",
              address: station.address || "",
              userTribe: station.userTribe || "",
              website: station.website || "",
              id_number: station.id_number || "",
              active: Boolean(station.active),
              user_membership: Array.isArray(station.user_membership) ? station.user_membership : [],
              activation: Array.isArray(station.activation) ? station.activation : [],
            };
          }

          this.editUserDialog = true;
        }
      } catch (err) {
        console.error("Error fetching buying station details:", err);
        this.$notify({
          text: err?.data?.message || "Error fetching buying station details",
          type: "error",
        });
      }
    },

    openConfirmActivate(id) {
      const entity = this.isNaccuUser ? this.$t("memberDataSection.factory").toLowerCase() : this.$t("memberDataSection.buyingStation").toLowerCase();
      this.confirmStatus = {
        title: this.$t("memberDataSection.confirmDialog.activate.title"),
        message: this.$t("memberDataSection.confirmDialog.activate.message", { entity }),
        confirmBtnText: this.$t("memberDataSection.confirmDialog.activate.confirmBtn"),
        confirmData: { id, action: "activate" },
      };
      this.confirmStatusDialog = true;
    },

    openConfirmDeactivate(id) {
      const entity = this.isNaccuUser ? this.$t("memberDataSection.factory").toLowerCase() : this.$t("memberDataSection.buyingStation").toLowerCase();
      this.confirmStatus = {
        title: this.$t("memberDataSection.confirmDialog.deactivate.title"),
        message: this.$t("memberDataSection.confirmDialog.deactivate.message", { entity }),
        confirmBtnText: this.$t("memberDataSection.confirmDialog.deactivate.confirmBtn"),
        confirmData: { id, action: "deactivate" },
      };
      this.confirmStatusDialog = true;
    },

    async handleConfirmStatus(_action, confirmData) {
      this.confirmStatusDialog = false;
      if (!confirmData?.id) return;
      if (confirmData.action === "activate") {
        await this.activateBuyingStation(confirmData.id);
      } else if (confirmData.action === "deactivate") {
        await this.deactivateBuyingStation(confirmData.id);
      }
    },

    async activateBuyingStation(id) {
      this.loading = true;
      
      try {
        await BuyingStationService.activateBuyingStation(id);
        this.getBuyingStations();
        this.$notify({
          text: this.isNaccuUser ? this.$t("memberDataSection.factoryActivatedSuccessfully") : this.$t("memberDataSection.activatedSuccessfully"),
          type: "success",
        });
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$notify({
          text: err.response?.data?.message || "Error activating buying station",
          type: "error",
        });
        console.log("Error", err);
      }
    },

    async deactivateBuyingStation(id) {
      this.loading = true;
      
      try {
        await BuyingStationService.deactivateBuyingStation(id);
        this.getBuyingStations();
        this.$notify({
          text: this.isNaccuUser ? this.$t("memberDataSection.factoryDeactivatedSuccessfully") : this.$t("memberDataSection.deactivatedSuccessfully"),
          type: "success",
        });
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$notify({
          text: err.response?.data?.message || "Error deactivating buying station",
          type: "error",
        });
        console.log("Error", err);
      }
    },

    selectItem(item) {
      this.selectedItem = item;
    },
    resetSearchOnEmpty() {
      this.search = "";
      this.options = {
        page: 1,
        limit: 10,
      };
      this.getBuyingStations();
    },
    reportPageChange(t) {
      if (t) this.options.page = this.options.page + 1;
      else this.options.page = this.options.page - 1;
      this.getBuyingStations();
    },

    // Add User Dialog event handlers
    closeAddUserDialog() {
      this.addUserDialog = false;
    },

    handleUserAdded(result) {
      if (result.success) {
        this.getBuyingStations();
      }
    },

    // Edit User Dialog event handlers
    closeEditUserDialog() {
      this.editUserDialog = false;
      this.selectedBuyingStation = null;
    },

    handleUserUpdated(result) {
      if (result.success) {
        this.$notify({
          text: result.message,
          type: "success",
        });
        this.getBuyingStations();
      } else {
        this.$notify({
          text: result.message,
          type: "error",
        });
      }
    },

    // User Selection Modal handlers
    closeUserSelectionDialog() {
      this.userSelectionDialog = false;
    },

    handleManageRoles() {
      this.$router.push({ name: "CoffeeBuyingStationRoles" });
    },

    handleUserOptionSelected(option) {
      this.userSelectionDialog = false;
      if (option === 'single') {
        // Single factory registration -> the rich register-buying-station page (with connected users).
        this.$router.push({ name: "CoffeeRegisterBuyingStation" });
      } else if (option === 'multiple') {
        // Multiple factories -> file bulk upload.
        this.bulkUploadDialog = true;
      }
    },

    // Bulk Upload Dialog handlers
    closeBulkUploadDialog() {
      this.bulkUploadDialog = false;
    },

    handleBulkUploadCompleted(result) {
      if (result.success) {
        this.getBuyingStations();
      }
    },
  },
  mixins: [loadingMixin, download, getPermittedActions, DateMixin, RoleMixin],
};
</script>


<style lang="scss" scoped>
.blue-button {
  background-color: #d0e6fe !important;
  border: 2px solid #002287 !important;
  color: #002287 !important;
}

.orange-button {
  background-color: #fff7ec !important;
  border: 2px solid #ffa826 !important;
  color: #ffa826 !important;
}

::v-deep .wdt.v-text-field {
  width: 250px;
}

::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}

::v-deep .v-data-table-header span {
  text-transform: uppercase !important;
  color: black;
}

::v-deep .center-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .img-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 40%;
}

.gray-button {
  background-color: #e8e8e8 !important;
  border: 2px solid #000000 !important;
  color: #000000 !important;
}

.green-button {
  background-color: #d4edda !important;
  border: 2px solid #28a745 !important;
  color: #28a745 !important;
}

.red-button {
  background-color: #f8d7da !important;
  border: 2px solid #dc3545 !important;
  color: #dc3545 !important;
}

/* Dynamic icon colors for rebranding */
.dynamic-icon-color {
  color: var(--primary-color, #00BD73) !important;
}

/* Indonesian client specific icon color */
[data-theme="indonesian"] .dynamic-icon-color {
  color: #184980 !important;
}

/* Kenya client specific icon color */
[data-theme="kenya"] .dynamic-icon-color {
  color: #A75300 !important;
}

/* Default client icon color */
.dynamic-icon-color {
  color: var(--primary-color, #00BD73) !important;
}
</style>
